// eslint-disable-next-line import/prefer-default-export
export const PROJECT_FULL_ACCESS = "project:full-access";
